import React, { useEffect, useMemo, useState } from "react";
import { Breadcrumb } from "../../components/ui/Breadcrumb";
import { useLocation, useNavigate } from "react-router-dom";
import RequestFailed from "../../components/alerts/RequestFailed";
import { useSelector } from "react-redux";
import OrganizationRepository from "../../repositories/OrganizationRepository";

const ErrorPage = () => {
    const location = useLocation();
    const navigate = useNavigate();

    const [show, setShow] = useState(false);

    useEffect(() => {
        if (!location.state?.show) {
            navigate("/", { replace: true });
            return;
        }

        setShow(true);
    }, [location, navigate]);

    const { organizationPreference } = useSelector(
        (state) => state.preferenceSlice
    );

    const { organizations: allOrganizations, parentOrganizations } =
        useSelector((state) => state.userDetails);

    // Route navigation always uses the numeric ORGANIZATIONID (IDHP) / orgId GUID (ODS, same value as ORGANIZATIONID),
    // never the ISF id that organizationPreference is stored in.
    const employeeUrl = useMemo(() => {
        if (organizationPreference.length === 0) {
            return parentOrganizations.length === 1
                ? `/organization/${parentOrganizations[0].ORGANIZATIONID}/employees/search`
                : "";
        }

        const preferredOrganization =
            OrganizationRepository.getOrganizationByStandardId(
                allOrganizations,
                organizationPreference[0]
            );

        return preferredOrganization
            ? `/organization/${preferredOrganization.ORGANIZATIONID}/employees/search`
            : "";
    }, [organizationPreference, parentOrganizations, allOrganizations]);

    return (
        <div>
            {show && (
                <>
                    {/* TODO: Make this generic */}
                    <Breadcrumb
                        links={[
                            {
                                path: "/search",
                                name: "Search",
                            },
                            {
                                path: employeeUrl,
                                name: "Employee",
                            },
                            {
                                name: "Claim & Leave",
                            },
                        ]}
                    />

                    <RequestFailed
                        tabIndex={0}
                        message={
                            "Your search failed, please try again or contact us for further assistance."
                        }
                        label="claim & leave"
                        attribute1="claim & leave"
                        attribute3="claim_error"
                    />
                </>
            )}
        </div>
    );
};

export default ErrorPage;
